// extracted by mini-css-extract-plugin
export default {"banner":"CJYid","inner":"pgLeF","title":"Dl7v1"};